import {useEffect} from 'react';
import {fabric} from 'fabric';

export const useImageSizeLimits = (canvas, {min, max}) => {
  useEffect(() => {
    if (!canvas) return;

    const enforceSizeLimits = (obj) => {
      // eslint-disable-next-line no-underscore-dangle
      if (!obj || obj.type !== 'uYOImage' || !obj._originalElement) return;

      const originalScale = fabric.util.findScaleToCover(obj, obj._originalObject);
      const currentScale = obj.scaleX / originalScale;

      if (currentScale < min) {
        const newScale = originalScale * min;
        obj.set({minScaleLimit: newScale, lockScalingFlip: true});
        obj.scale(newScale);
        canvas.requestRenderAll();
      } else if (currentScale > max) {
        const newScale = originalScale * max;
        obj.scale(newScale);
        canvas.requestRenderAll();
      }
    };

    const handleScaling = (e) => {
      enforceSizeLimits(e.target);
    };

    canvas.on('object:scaling', handleScaling);

    // eslint-disable-next-line consistent-return
    return () => {
      canvas.off('object:scaling', handleScaling);
    };
  }, [canvas, min, max]);

  return null;
};
